import UiCalculator from '../../../common/Component/UiCalculator';
import CurrentShop from '../../../common/currentShop';
import PriceSwitchController from '../../../common/priceSwitch/Controller/priceSwitchController';
import CustomerShopHint from '../Component/CustomerShopHint';
import HomieAi from '../Component/HomieAi';
import {LanguageNavigation} from '../Component/LanguageNavigation';
import LoginDropdown from '../Component/LoginDropdown';
import MainNavigation from '../Component/MainNavigation';
import MetaNavigation from '../Component/MetaNavigation';
import RecombeeSearch from '../Component/RecombeeSearch';
import {SideNavigation} from '../Component/SideNavigation';

export default class HeaderController {
    private readonly mainNavElement: HTMLElement;
    private readonly sideNavigation: SideNavigation;
    private readonly SIDENAV_BREAKPOINT = 1280;

    private readonly currentShop: CurrentShop;
    private readonly mainNavigation: MainNavigation;
    private metaNavigation: MetaNavigation;
    private headerLanguageNavigation: LanguageNavigation | null = null;
    private sidebarLanguageNavigation: LanguageNavigation | null = null;
    private recombeeSearch: RecombeeSearch | null = null;
    private readonly uiCalculator: UiCalculator;
    private readonly loginDropdown: LoginDropdown;
    private readonly homieAi: HomieAi;
    private readonly priceSwitch: PriceSwitchController;

    constructor() {
        this.currentShop = new CurrentShop();
        this.mainNavigation = new MainNavigation();
        this.mainNavElement = document.getElementById('main_nav')!;
        this.sideNavigation = new SideNavigation();
        this.metaNavigation = new MetaNavigation();
        this.recombeeSearch = new RecombeeSearch();
        this.uiCalculator = new UiCalculator();
        this.loginDropdown = new LoginDropdown();
        this.homieAi = new HomieAi();
        this.priceSwitch = new PriceSwitchController();

        this.instantiateHeaderModules();
        this.updateHeaderHeightCssVariable();
        this.initCallbacks();
        this.adjustNavigationVisibility();

        window.addEventListener('resize', () => {
            this.adjustNavigationVisibility();
            requestAnimationFrame(() => {
                this.updateHeaderHeightCssVariable();
            });
        });
    }

    private instantiateHeaderModules(): void {
        this.headerLanguageNavigation = new LanguageNavigation('#header .language-switch');
        this.sidebarLanguageNavigation = new LanguageNavigation('.sidebar-navigation .language-switch');

        if (this.currentShop.isDaiberShop()) {
            new CustomerShopHint();
        }
    }

    private initCallbacks(): void {
        this.mainNavigation.onMenuOpen(() => {
            this.headerLanguageNavigation?.closeDropdown();
            this.recombeeSearch?.closeResult();
            this.loginDropdown.closeMenu();
            this.closeOverlayLayer();
        });

        this.headerLanguageNavigation?.setOnMenuOpenCallback(() => {
            this.mainNavigation.closeAllMenus();
            this.recombeeSearch?.closeResult();
            this.loginDropdown.closeMenu();
            this.closeOverlayLayer();
        });

        this.recombeeSearch?.setFocusCallback(() => {
            this.headerLanguageNavigation?.closeDropdown();
            this.mainNavigation.closeAllMenus();
            this.loginDropdown.closeMenu();
            this.closeOverlayLayer();
        });

        this.loginDropdown.onMenuOpen(() => {
            this.headerLanguageNavigation?.closeDropdown();
            this.mainNavigation.closeAllMenus();
            this.recombeeSearch?.closeResult();
            this.closeOverlayLayer();
        });
    }

    private adjustNavigationVisibility(): void {
        const isMobile = window.innerWidth < this.SIDENAV_BREAKPOINT;

        if (isMobile) {
            this.sideNavigation.applyAriaState();
            this.mainNavElement.setAttribute('inert', 'true');
            this.mainNavElement.setAttribute('aria-hidden', 'true');
        } else {
            this.mainNavElement.removeAttribute('inert');
            this.mainNavElement.removeAttribute('aria-hidden');
            this.sideNavigation.close();
            this.closeOverlayLayer();
        }
    }

    private updateHeaderHeightCssVariable(): void {
        const header = document.getElementById('header');
        if (!header) return;

        const height = header.offsetHeight;
        const styleTag = document.getElementById('dynamic-css-vars') as HTMLStyleElement;

        if (styleTag) {
            styleTag.textContent = `body { --clx-header-height-including-notification-bar: ${height}px; }`;
        }
    }

    private closeOverlayLayer(): void {
        const overlay = document.querySelector('.overlay');
        if (overlay) overlay.remove();
    }
}
